module.exports = __webpack_public_path__ + "img/payment-method-tng.fd175361.png";